import { LegendTemplateModelDc } from "@evergis/api";

import { HORIZONTAL_LEGEND_WIDTH, VERTICAL_LEGEND_WIDTH } from "./templateConfig";
import { createLegendLayers } from "./createLegendLayers";
import { clamp } from "../../../utils/math";
import { PrintTemplate } from "./PrintTemplate";
import { LegendPosition, PrintTemplateType } from "../../../interfaces/print";

const MAX_LEGENDS_IN_ROW = 4;

export class LegendTemplate extends PrintTemplate<LegendTemplateModelDc> {
  static TYPE = PrintTemplateType.Legend;

  public async serialize(): Promise<LegendTemplateModelDc> {
    const { layers, defaultScaleRange } = this.printInfo;
    const printFormat = this.getPrintFormatInfo();

    return {
      type: LegendTemplate.TYPE,
      layers: this.printInfo.layers.map(this.createLayerModel),
      legendEnabled: true,
      legendLayers: await createLegendLayers(layers, defaultScaleRange),
      ...printFormat,
      fileName: `${printFormat.fileName}Legend`,
    };
  }

  protected getWidth(): number {
    const { layers, settings } = this.printInfo;
    const { legend } = settings;
    const layersLenK = layers ? clamp(layers.length, 0, MAX_LEGENDS_IN_ROW) : 0;

    return legend && legend.position === LegendPosition.Horizontal
      ? HORIZONTAL_LEGEND_WIDTH * layersLenK
      : VERTICAL_LEGEND_WIDTH;
  }
}
